import { render } from "./PostCardEnterComment.vue?vue&type=template&id=f2eb5aec&scoped=true"
import script from "./PostCardEnterComment.vue?vue&type=script&lang=js"
export * from "./PostCardEnterComment.vue?vue&type=script&lang=js"

import "./PostCardEnterComment.vue?vue&type=style&index=0&id=f2eb5aec&scoped=true&lang=css"

import exportComponent from "../../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f2eb5aec"]])

export default __exports__